var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUsers = function SvgUsers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.25 10.5a8.75 8.75 0 0 1-8.75 8.75 8.75 8.75 0 0 1-8.75-8.75 8.75 8.75 0 0 1 8.75-8.75 8.75 8.75 0 0 1 8.75 8.75m-6.125-2.625a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0M10.5 17.938a7.4 7.4 0 0 0 4.206-1.303c.529-.364.754-1.055.446-1.617-.636-1.167-1.948-1.893-4.652-1.893s-4.016.726-4.653 1.893c-.307.562-.082 1.253.447 1.617a7.4 7.4 0 0 0 4.206 1.302",
    clipRule: "evenodd"
  })));
};
export default SvgUsers;